import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  FileText, 
  Settings, 
  DollarSign, 
  Image, 
  Utensils 
} from 'lucide-react';

const TABS = [
  { 
    id: 'basic', 
    icon: FileText, 
    activeClass: 'border-blue-500 text-blue-600',
    iconColor: 'text-blue-600'
  },
  { 
    id: 'details', 
    icon: Settings, 
    activeClass: 'border-green-500 text-green-600',
    iconColor: 'text-green-600'
  },
  { 
    id: 'pricing', 
    icon: DollarSign, 
    activeClass: 'border-purple-500 text-purple-600',
    iconColor: 'text-purple-600'
  },
  { 
    id: 'image', 
    icon: Image, 
    activeClass: 'border-orange-500 text-orange-600',
    iconColor: 'text-orange-600'
  },
  { 
    id: 'meals', 
    icon: Utensils, 
    activeClass: 'border-indigo-500 text-indigo-600',
    iconColor: 'text-indigo-600'
  }
];

export default function SubscriptionTabs({ activeTab, onTabChange }) {
  const { t } = useTranslation();

  return (
    <div className="border-b border-gray-200 mb-8">
      <nav className="flex space-x-8 overflow-x-auto rtl:space-x-reverse">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          const Icon = tab.icon;
          
          return (
            <button
              key={tab.id}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onTabChange(tab.id);
              }}
              className={`
                flex items-center gap-3 px-1 py-4 text-sm font-medium border-b-2 transition-all duration-200
                whitespace-nowrap hover:bg-gray-50 rounded-t-lg px-4
                ${isActive 
                  ? `${tab.activeClass} bg-gray-50`
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              <Icon 
                className={`w-5 h-5 ${isActive ? tab.iconColor : 'text-gray-400'}`} 
              />
              <span className="hidden sm:inline">{t(`subscriptionTabs.${tab.id}`)}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
